<template>
  <div>
    <main-layout>
      <div>
        <div v-if="currentView == 'list'">
          <v-container>
            <h2 class="headline">{{ $t('Draft') }}</h2>
            <template v-if="loading">
              <div class="text-xs-center" style="padding: 10px 0px">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="35px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <template v-else>
              <div class="broadcasts">
                <div style="margin-bottom: 15px">
                  <a
                    href="javascript:void(0);"
                    @click="
                      selected_edit_broadcast = undefined
                      currentView = 'edit'
                      isSaveOnly = false
                    "
                    style="text-decoration: none"
                  >
                    <div class="add-broadcast text-xs-center">
                      <em class="fa fa-plus middle" />
                      {{ $t('Add new broadcast') }}
                    </div>
                  </a>
                </div>

                <div
                  style="
                    background: #ffffff 0% 0% no-repeat padding-box;
                    border-radius: 26px;
                    padding: 20px;
                  "
                >
                  <h2 class="headline mb-3">{{ $t('Draft') }}</h2>
                  <template v-if="draft_broadcasts && draft_broadcasts.length > 0">
                    <div
                      class="broadcast mb-3"
                      v-for="(broadcast, index) in draft_broadcasts"
                      :key="'draft_broadcast_' + index"
                    >
                      <broadcast-item
                        @editBroadcast="editBroadcast"
                        @copyBroadcast="copyBroadcast"
                        @deleteBroadcast="deleteBroadcast"
                        :broadcast="broadcast"
                        :index="index"
                        :draft="true"
                      ></broadcast-item>
                    </div>
                  </template>
                  <template v-else>
                    <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
                  </template>
                </div>
              </div>
            </template>
            <br />
            <div
              v-if="schedule_broadcasts && schedule_broadcasts.length > 0"
              style="
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 26px;
                padding: 20px;
              "
            >
              <h2 class="mb-3 headline">{{ $t('schduled_broadcast') }}</h2>
              <div class="broadcasts">
                <div
                  class="broadcast mb-3"
                  v-for="(broadcast, index) in schedule_broadcasts"
                  :key="'schedule_broadcast_' + index"
                >
                  <broadcast-item
                    @editBroadcast="editBroadcast"
                    @copyBroadcast="copyBroadcast"
                    @deleteBroadcast="deleteBroadcast"
                    :broadcast="broadcast"
                    :index="index"
                    :draft="true"
                    :isSaveOnly="true"
                  ></broadcast-item>
                </div>
              </div>
            </div>
            <br />
            <div
              v-if="sent_broadcasts && sent_broadcasts.length > 0"
              style="
                background: #ffffff 0% 0% no-repeat padding-box;
                border-radius: 26px;
                padding: 20px;
              "
            >
              <h3 class="headline">{{ $t('Broadcasted') }}</h3>

              <template v-if="loading">
                <div class="text-xs-center" style="padding: 10px 0px">
                  <scale-loader
                    :color="$vuetify.theme.primary"
                    height="35px"
                    width="7px"
                  ></scale-loader>
                </div>
              </template>
              <template v-else>
                <div class="broadcasts">
                  <template>
                    <div
                      class="broadcast mb-3"
                      v-for="(broadcast, index) in sent_broadcasts"
                      :key="'sent_broadcast_' + index"
                    >
                      <broadcast-item
                        @editBroadcast="editBroadcast"
                        @copyBroadcast="copyBroadcast"
                        @viewBroadcast="viewBroadcast"
                        :broadcast="broadcast"
                        :index="index"
                        :draft="false"
                      ></broadcast-item>
                    </div>
                  </template>
                </div>
                <v-pagination
                  @input="changepage"
                  v-model="page"
                  :length="pagelength"
                  :total-visible="7"
                ></v-pagination>
                <v-progress-linear
                  v-if="pageloading"
                  height="2px"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </template>
            </div>
          </v-container>
          <div class="mt-5 mb-5"></div>
        </div>
        <div v-if="currentView == 'edit'">
          <template v-if="currentView == 'edit'">
            <broadcast-manage
              @onClose="onClose"
              :value="selected_edit_broadcast"
              :isSaveOnly="isSaveOnly"
              @onSave="onSave"
            ></broadcast-manage>
          </template>
        </div>
        <div v-if="currentView == 'view'">
          <template v-if="selected_view_broadcast">
            <broadcast-view @onClose="onClose" :value="selected_view_broadcast"></broadcast-view>
          </template>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import BroadcastManage from './BroadcastManage'
import BroadcastView from './BroadcastView'
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import BroadcastItem from './BroadcastItem.vue'
import gpfBuddyApi from '@/api/gpf-buddy'
import lamyApi from '@/api/lamy'
import { PAGE } from '@/constants/page.js'

export default {
  data: function () {
    return {
      copy_name: '',
      sent_name: '',
      isSave: false,
      pageloading: false,
      isCopy: false,
      currentView: 'list',
      isFail: false,
      draft_broadcasts: [],
      sent_broadcasts: [],
      schedule_broadcasts: [],
      selected_edit_broadcast: undefined,
      selected_view_broadcast: undefined,
      loading: true,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 1,
      limit: 10,
      isSaveOnly: false
    }
  },
  components: {
    BroadcastManage,
    BroadcastView,
    ScaleLoader,
    BroadcastItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / 10)
      } else {
        return 1
      }
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    }
  },
  mounted: function () {
    const vm = this

    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
    vm.loading = true
    vm.getBroadcast(function () {
      vm.loading = false
    }, 'draft')
    vm.getBroadcast(function () {
      vm.loading = false
    }, 'broadcasted')
    vm.$store.dispatch('loadStatus')

    if (this.selectedBot.theme == 'universalutilities') {
      vm.$store.dispatch('loadLinePushMessageCount', {
        dateform: moment().startOf('month').format('YYYY-MM-DD'),
        dateto: moment().endOf('month').format('YYYY-MM-DD')
      })
    }

    if (vm.isGpfBuddy) {
      vm.getGpfBuddyMasterData()
    }

    if (vm.isLamy) {
      vm.getLamyProductMasterData()
    }
  },
  methods: {
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getBroadcast(function () {
          vm.loading = false
        }, 'broadcasted')
      }
    },
    onClose: function (payload) {
      var vm = this
      vm.currentView = 'list'
      vm.loading = true
      if (payload) {
      }
      vm.getBroadcast(function () {
        vm.loading = false
      }, 'draft')
      vm.getBroadcast(function () {
        vm.loading = false
      }, 'broadcasted')
    },
    getBroadcast: function (callback, status) {
      var vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      vm.pageloading = true

      var data = {}
      if (status == 'broadcasted') {
        data = { pageid: vm.selectedBot.pageid, limit: vm.limit, offset: vm.offset, status }
      } else {
        data = { pageid: vm.selectedBot.pageid, status }
      }
      api.getBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.pageloading = false

        if (response.data) {
          if (status == 'broadcasted') {
            vm.pagetotal = parseInt(response.total)
            vm.sent_broadcasts.length = 0
          }
          if (status == 'draft') {
            vm.draft_broadcasts.length = 0
            vm.schedule_broadcasts.length = 0
          }
          $.each(response.data, function (index, broadcast) {
            if (status === 'draft' && broadcast.status == 'draft') {
              vm.draft_broadcasts.push(broadcast)
            } else if (broadcast.isschedule && status == 'draft' && broadcast.status == 'sent') {
              vm.schedule_broadcasts.push(broadcast)
            } else {
              vm.sent_broadcasts.push(broadcast)
            }
          })
        }
        callback()
      })
    },
    editBroadcast: function (broadcasts, isSaveOnly) {
      const vm = this
      vm.selected_edit_broadcast = broadcasts
      vm.currentView = 'edit'
      vm.isSaveOnly = isSaveOnly
    },
    viewBroadcast: function (index) {
      var vm = this
      this.selected_view_broadcast = this.sent_broadcasts[index]
      vm.$nextTick(function () {
        vm.currentView = 'view'
      })
    },
    deleteBroadcast: function (broadcastid, broadcastname, isSaveOnly) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: broadcastname.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            api.deleteBroadcast(
              { pageid: vm.selectedBot.pageid, broadcastid: broadcastid },
              function (error, response) {
                if (error) {
                  console.error(error)
                  // vm.loading = true
                  return
                }

                if (isSaveOnly) {
                  vm.schedule_broadcasts.map((broadcast, index) => {
                    if (broadcast.id == broadcastid) {
                      vm.schedule_broadcasts.splice(index, 1)
                      return false
                    }
                  })
                } else {
                  vm.draft_broadcasts.map((broadcast, index) => {
                    if (broadcast.id == broadcastid) {
                      vm.draft_broadcasts.splice(index, 1)
                      return false
                    }
                  })
                }
              }
            )
          }
        })
    },
    onSave: function (payload) {
      var vm = this
      vm.saveBroadcast(payload.data, function (status, id) {
        payload.onSave(status, id)
      })
    },
    copyBroadcast: function (payload, type) {
      var vm = this
      var data = null

      var broadcast = null
      if (payload == null) return false
      if (type === 'draft') {
        broadcast = vm.draft_broadcasts.find((el) => {
          return el.id == payload.id
        })
        if (broadcast) data = Object.assign({}, broadcast)
      } else if (type === 'sent') {
        broadcast = vm.sent_broadcasts.find((el) => {
          return el.id == payload.id
        })
        if (broadcast) data = Object.assign({}, broadcast)
      }
      if (data == null) return false
      vm.$swal
        .fire({
          title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            data.id = null
            data.name += ' copy'
            ;(data.sendflag = false),
              (data.page_access_token = vm.selectedBot.page_access_token),
              (vm.copy_name = data.name)
            vm.saveBroadcast(data, function (status, id) {
              if (status) {
                data.id = id
                vm.draft_broadcasts.unshift(data)
                vm.$swal.fire({
                  title: vm.$t('Broadcast {copy_name} copy', {
                    copy_name: data.name.replace(/\<|\>/g, '')
                  }),
                  type: 'success',
                  confirmButtonText: vm.$t('Confirm'),
                  cancelButtonText: vm.$t('cancel'),
                  reverseButtons: true
                })
              }
            })
          }
        })
    },
    saveBroadcast: function (data, callback) {
      api.updateBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback(false, null)
          return
        }
        var id = null
        if (response.broadcastid) {
          id = response.broadcastid
        }
        callback(true, id)
      })
    },
    async getGpfBuddyMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await gpfBuddyApi.getCompanyMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.gpfBuddyMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getLamyProductMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await lamyApi.getFilterProductMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.lamyFilterProductMasterData = response.data.filter
        }
      } catch (error) {
        console.error(error)
        return
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Broadcast.vue